import React from "react";
import "./Mission.css";
const Mission = () => {
  return (
    <div className="mission_parent_div">
      <h2>Mission and Vision </h2>
      <p>
        <b>Mission:</b> To provide high-quality and reliable construction
        services, ensuring customer satisfaction and project success.
      </p>
      <p>
        <b>Vision:</b> To be a leading contractor company recognized for
        excellence, efficiency, and sustainable construction solutions.
      </p>
      <p>
        <b>Core Values:</b> Integrity, Quality, Efficiency, Customer
        Satisfaction, and Sustainability
      </p>
    </div>
  );
};

export default Mission;
